// Inline glyphs ported from the prototype (design_handoff). Every SVG carries an
// explicit viewBox AND is sized by CSS (.icon-class svg { width/height }) — a
// viewBox-only SVG balloons to its intrinsic box, so the module CSS sizes each.
import type { ReactElement } from "react";

export const Ic = {
  search: (
    <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <circle cx="9" cy="9" r="5.5" stroke="currentColor" strokeWidth="1.5" />
      <path d="M13.5 13.5l3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
  check: (
    <svg viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path
        d="M2.5 7.5l3 3 6-7"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  plus: (
    <svg viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path d="M7 2v10M2 7h10" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  ),
  chevron: (
    <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path
        d="M5.5 8l4.5 4.5L14.5 8"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  tag: (
    <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path
        d="M10.4 3H4.5A1.5 1.5 0 003 4.5v5.9a1.5 1.5 0 00.44 1.06l5.6 5.6a1.5 1.5 0 002.12 0l4.94-4.94a1.5 1.5 0 000-2.12l-5.6-5.6A1.5 1.5 0 0010.4 3z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
      <circle cx="6.9" cy="6.9" r="1.05" fill="currentColor" />
    </svg>
  ),
  cols: (
    <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <rect x="3" y="4" width="14" height="12" rx="1.5" stroke="currentColor" strokeWidth="1.4" />
      <path d="M9 4v12M13.5 4v12" stroke="currentColor" strokeWidth="1.4" />
    </svg>
  ),
  funnel: (
    <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path
        d="M2 3.5h12l-4.5 5v4l-3 1.5v-5.5L2 3.5z"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinejoin="round"
      />
    </svg>
  ),
  person: (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="8.8" r="4" fill="currentColor" />
      <path d="M3.6 21.5c0-4.7 3.7-7.3 8.4-7.3s8.4 2.6 8.4 7.3z" fill="currentColor" />
    </svg>
  ),
  receipt: (
    <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path
        d="M5 3.5h10v13l-2-1.2-2 1.2-2-1.2-2 1.2V3.5z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
      <path d="M8 7.5h4M8 10.5h4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  ),
  people: (
    <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <circle cx="7" cy="7" r="2.6" stroke="currentColor" strokeWidth="1.4" />
      <path
        d="M2.5 16c.5-2.6 2.3-3.9 4.5-3.9s4 1.3 4.5 3.9"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M13 5.6a2.6 2.6 0 010 5M14.6 16c-.2-1.6-.9-3-2-3.6"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  ),
  chat: (
    <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path
        d="M4 4.5h12a1.5 1.5 0 011.5 1.5v6a1.5 1.5 0 01-1.5 1.5H8l-3.5 3v-3H4A1.5 1.5 0 012.5 12V6A1.5 1.5 0 014 4.5z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
    </svg>
  ),
} satisfies Record<string, ReactElement>;
